import { Check, Close, ContentPaste, ReportProblem } from "@mui/icons-material";
import { CircularProgress, Container, Divider, IconButton, Modal, Slide, Stack, styled } from "@mui/material";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "../../../../components/MDBox";
import MDButton from "../../../../components/MDButton";
import MDSnackbar from "../../../../components/MDSnackbar";
import MDTypography from "../../../../components/MDTypography";
import PopUp from "../../../../components/PopUp/PopUp";
import { clearConfirmAuthenticatorSetupErr, resetConfirmedAuthenticatorSetup, tryConfirmAuthenticatorSetup } from "../../../../stateManagement/reducers/authenticatorReducer";
import { tryConfirmLogin } from "../../../../stateManagement/reducers/authReducer";


const ConfigureAuthenticatorAppModal = ({ show, setShow }) => {

    const dispatch = useDispatch();
    const {
        user,
        authToken
    } = useSelector(state => state.auth);
    const {
        confirmingAuthenticatorSetup,
        confirmedAuthenticatorSetup,
        confirmAuthenticatorSetupErr
    } = useSelector(state => state.authenticator)
    const [toInputOTP, setToInputOTP] = useState(false);

    const [authenticatorSecret, setAuthenticatorSecret] = useState(user?.authenticatorSecret ?? null);

    const [otp, setOtp] = useState('');

    const [textCopySuccess, setTextCopySuccess] = useState(null);

    const closeTextCopySuccesss = () => setTextCopySuccess(null);

    const renderTextCopySuccess = (
        <MDSnackbar
            color="success"
            icon={<ContentPaste color="success" />}
            title="Copied!"
            content={textCopySuccess}
            dateTime="Just now"
            open={Boolean(textCopySuccess)}
            onClose={closeTextCopySuccesss}
            close={closeTextCopySuccesss}
            bgWhite
        />
    );

    const toggleModal = () => {
        setOtp("");
        setShow(!show);
    }

    const QRCodeImg = styled("img")({
        width: "100%",
        height: "100%"
    });

    const [formSuccess, setFormSuccess] = useState(null);
    const [formErr, setFormErr] = useState(null);

    const closeFormSuccesss = () => setFormSuccess(null);
    const closeFormErr = () => setFormErr(null);

    const renderFormErr = (
        <MDSnackbar
            color="error"
            icon={<ReportProblem color="error" />}
            title="Something Went Wrong"
            content={formErr ?? ""}
            dateTime="Just now"
            open={Boolean(formErr)}
            onClose={closeFormErr}
            close={closeFormErr}
            bgWhite
            sx={{
                position: "fixed",
                top: "1rem"
            }}
        />
    );

    const renderFormSuccess = (
        <MDSnackbar
            color="success"
            icon={<Check color="success" />}
            title="Check Your Inbox"
            content={formSuccess}
            dateTime="Just now"
            open={Boolean(formSuccess)}
            onClose={closeFormSuccesss}
            close={closeFormSuccesss}
            bgWhite
        />
    );

    const [isInitRender1, setIsInitRender1] = useState(true);
    useEffect(() => {
        if (isInitRender1) {
            setFormSuccess(null);
            setIsInitRender1(false);
            dispatch(resetConfirmedAuthenticatorSetup());
            return;
        }

        if (confirmedAuthenticatorSetup) {
            setFormSuccess("You can now perform 2FA authentication with your Authenticator App.");
            dispatch(tryConfirmLogin({ authToken: authToken ?? "" }));

            toggleModal();
        } else {
            setFormErr(null);
        }
    }, [confirmedAuthenticatorSetup]);

    const [isInitRender3, setIsInitRender3] = useState(true);
    useEffect(() => {
        if (isInitRender3) {
            dispatch(clearConfirmAuthenticatorSetupErr());
            setFormErr(null);
            setIsInitRender3(false);
            return;
        }

        if (confirmAuthenticatorSetupErr) {
            setFormErr(confirmAuthenticatorSetupErr);
        } else {
            setFormErr(null);
        }
    }, [confirmAuthenticatorSetupErr]);

    useEffect(() => {

        if (otp.length === 6) {
            dispatch(tryConfirmAuthenticatorSetup({
                authToken: authToken ?? "",
                otp
            }));
        }

    }, [otp]);

    return (
        <>
            <MDBox component="section" py={6} px={2}>
                <Container>
                    <Modal
                        open={show} onClose={toggleModal} 
                        sx={{ 
                            display: "grid", 
                            placeItems: "center",
                            maxHeight: '100vh !important',
                            overflowY: 'auto !important',
                            p: '1rem !important',

                        }}

                    >
                        <Slide direction="down" in={show} timeout={500}>
                            <MDBox
                                sx={{
                                    maxWidth: "500px"
                                }}
                                position="relative"
                                display="flex"
                                flexDirection="column"
                                borderRadius="xl"
                                bgColor="white"
                                shadow="xl"
                            >
                                <MDBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                                    <MDTypography variant="h5">Configure Your Authenticator App</MDTypography>
                                    <Close fontSize="medium" sx={{ cursor: "pointer" }} onClick={toggleModal} />
                                </MDBox>
                                <Divider textAlign="center" sx={{ my: 0 }} />
                                <MDBox p={2}>
                                    {
                                        !toInputOTP

                                        &&

                                        <>
                                            <MDBox>
                                                <Stack alignItems="center" sx={{ width: "100%" }}>
                                                    <MDBox sx={{ height: "10rem", width: "10rem" }} >
                                                        <QRCodeImg src={authenticatorSecret.qrCodeData} />
                                                    </MDBox>
                                                    <MDTypography display="block" variant="button" color="secondary" my={0}>
                                                        Scanned the Q.R-Code using your Authenticator App?
                                                    </MDTypography>
                                                    <MDBox mt={1} mb={1}>
                                                        <MDButton
                                                            variant="gradient"
                                                            color="success"
                                                            fullWidth
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                setToInputOTP(true);
                                                            }}
                                                        >
                                                            Continue
                                                        </MDButton>
                                                    </MDBox>
                                                </Stack>
                                            </MDBox>
                                            <Divider sx={{ my: 3 }}>
                                                <MDTypography mt={-2} sx={{ textAlign: "center" }} variant={"h4"}  >OR</MDTypography>
                                            </Divider>
                                            <MDBox>
                                                <Stack px={2} alignItems="center" sx={{ width: "100%" }}>
                                                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }} >
                                                        <MDTypography variant="button" sx={{}} mr={2}><b>Secret Key:</b></MDTypography>
                                                        <IconButton
                                                            onClick={() => {
                                                                navigator.clipboard.writeText(authenticatorSecret.secret).then(() => {
                                                                    closeTextCopySuccesss();
                                                                    setTextCopySuccess("The Secret key has been copied to your clipboard. Now, paste it into your Authenticator App.");
                                                                });
                                                            }}
                                                            sx={{ position: "relative", right: -8 }}
                                                            mr={-1}
                                                        >
                                                            <ContentPaste />
                                                        </IconButton>
                                                    </Stack>
                                                    <MDBox bgColor="secondary" sx={{ width: '100%', overflowX: 'auto', position: 'relative', height: '2.25rem', overflowY: 'hidden' }} >
                                                        <MDTypography variant='button' color="black" textAlign='left' p={1} width="fit-content" sx={{ position: 'absolute' }}>
                                                            {authenticatorSecret.secret}
                                                        </MDTypography>
                                                    </MDBox>
                                                    <MDTypography display="block" variant="button" color="secondary" mt={1}>
                                                        Copied the secret key into your Authenticator App?
                                                    </MDTypography>
                                                    <MDBox mt={1} mb={1}>
                                                        <MDButton
                                                            variant="gradient"
                                                            color="success"
                                                            fullWidth
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                setToInputOTP(true);
                                                            }}
                                                        >
                                                            Continue
                                                        </MDButton>
                                                    </MDBox>
                                                </Stack>
                                            </MDBox>
                                        </>
                                    }
                                    {
                                        toInputOTP

                                        &&

                                        <>
                                            <MDBox mt={0} mb={1}>
                                                <MDTypography
                                                    sx={{
                                                        fontSize: "1rem"
                                                    }}
                                                    mb={4}
                                                >Now, input the O.T.P displayed in your Authenticator App</MDTypography>
                                                <Stack
                                                    sx={{ width: "100%" }}
                                                    spacing={1}
                                                >
                                                    <MuiOtpInput
                                                        id='otpField'
                                                        value={otp}
                                                        onChange={(newVal) => {
                                                            setOtp(newVal);
                                                        }}
                                                        inputMode='numeric'
                                                        length={6}
                                                    />
                                                </Stack>
                                            </MDBox>
                                        </>
                                    }
                                </MDBox>
                                <Divider sx={{ my: 0 }} />
                                <MDBox display="flex" justifyContent="space-between" p={1.5}>
                                    {
                                        !toInputOTP

                                        &&

                                        <>
                                            <MDButton variant="gradient" color="dark" onClick={toggleModal}>
                                                close
                                            </MDButton>
                                            <MDButton variant="gradient" color="success" onClick={() => setToInputOTP(true)}>
                                                Continue
                                            </MDButton>
                                        </>
                                    }
                                    {
                                        toInputOTP

                                        &&

                                        <>
                                            <MDButton variant="gradient" color="error" onClick={() => setToInputOTP(false)}>
                                                Back
                                            </MDButton>
                                            <MDButton variant="gradient" color="success" onClick={() => setToInputOTP(true)}>
                                                Confirm O.T.P
                                            </MDButton>
                                        </>
                                    }

                                </MDBox>
                            </MDBox>
                        </Slide>
                    </Modal>
                </Container>
            </MDBox>
            {renderTextCopySuccess}
            {renderFormErr}
            {renderFormSuccess}
            {
                (confirmingAuthenticatorSetup)

                &&

                <PopUp id='setup-authenticator-popup2' notCloseable deployed={confirmingAuthenticatorSetup} setDeployed={(truth) => { }} >
                    <MDBox>
                        <CircularProgress color='info' />
                    </MDBox>
                </PopUp>
            }
        </>
    );
}

export default ConfigureAuthenticatorAppModal;